import { render, staticRenderFns } from "./DealPackActionList.vue?vue&type=template&id=ac836036&scoped=true&"
import script from "./DealPackActionList.vue?vue&type=script&lang=js&"
export * from "./DealPackActionList.vue?vue&type=script&lang=js&"
import style0 from "./DealPackActionList.vue?vue&type=style&index=0&id=ac836036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac836036",
  null
  
)

export default component.exports